import { getMangoApiClient } from '~/atoms/MangoApi'

import { createSystemSettingsApi } from '@mangovoice/system-settings-ui'

export const systemSettingsApi = createSystemSettingsApi(
  getMangoApiClient().systemSettings.transport,
)
